import {
  TICKET_FORM_OPEN,
  TICKET_FORM_RESET,
  TICKET_FORM_CHANGE,
  TICKET_FORM_SEND_REQUEST,
  TICKET_FORM_SEND_SUCCESS,
  TICKET_FORM_SEND_FAILURE,
} from 'app/actions/assistance/ticketForm';
import { FILE_DELETE } from 'app/actions/assistance/files';
import update from 'react-addons-update';

export type formDataType = {
  email: string,
  updateEmail: bool,
  subjectId: number|null,
  content: string,
  filesAccepted: Array<number>,
  filesRejected: Array<string>,
};

const formData = {
  email: '',
  updateEmail: false,
  subjectId: null,
  content: '',
  filesAccepted: [],
  filesRejected: [],
};

const defaultState = {
  sending: false,
  ticket: { ...formData },
  save: { ...formData }, // currently not used
};

const ticketForm = (state = defaultState, action) => {
  switch (action.type) {

    case TICKET_FORM_OPEN: {
      const newState = update(state, { ticket: { $merge: action.payload } });
      return update(newState, { save: { $merge: action.payload } });
    }

    case TICKET_FORM_CHANGE: {
      return update(state, { ticket: { $merge: action.payload } });
    }

    case TICKET_FORM_RESET: {
      return defaultState;
    }

    case TICKET_FORM_SEND_REQUEST: {
      return { ...state, sending: true };
    }

    case TICKET_FORM_SEND_SUCCESS:
    case TICKET_FORM_SEND_FAILURE: {
      return { ...state, sending: false };
    }

    case FILE_DELETE: {
      const filesAccepted = state.ticket.filesAccepted.filter(id => (id !== action.payload));
      const filesRejected = state.ticket.filesRejected.filter(id => (id !== action.payload));
      return update(state, { ticket: { $merge: { filesAccepted, filesRejected } } });
    }

    default:
  }
  return state;
};

export default ticketForm;
